const subscribeTypeTextHash = {
	broadcastThematic: 'тематику',
	streamingPlace: 'площадку'
};

export const successEntitySubscribeMessage = (title, subscribeType) =>
	`Вы подписались на ${subscribeTypeTextHash[subscribeType]} «${title}»! Все подписки можно увидеть в личном кабинете.`;

export const unsubscribeConfirmationMessage = (title, subscribeType) =>
	`Отказаться от подписки на ${subscribeTypeTextHash[subscribeType]} «${title}»?`;

export const authForSubscribeMessage = (subscribeType) =>
	`Чтобы подписаться на ${subscribeTypeTextHash[subscribeType]} — авторизуйтесь на портале.`;

export const successAddFavoritesMessage = (title) =>
	`Вы добавили трансляцию «${title}» в «Избранное». Все сохраненные трансляции вы можете посмотреть в личном кабинете.`;
